import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SandboxApi } from "./types"


interface Error {
  error: unknown;
}

export function isError(response: unknown): response is Error {
  return typeof response === "object" && response != null && "error" in response;
};

/**
 * Type predicate to narrow an unknown error to `FetchBaseQueryError`
 */
export function isFetchBaseQueryError(
  error: unknown
): error is FetchBaseQueryError {
  return typeof error === "object" && error != null && "status" in error
}

export function isValidationErrorDetails(
  data: unknown
): data is SandboxApi.ValidationErrorDetails {
  return typeof data === "object" && data != null && "status" in data && "title" in data && "errors" in data
}

/**
 * Type predicate to narrow an unknown error to an object with a string "message" property
 */
export function isErrorWithMessage(
  error: unknown
): error is { message: string } {
  return (
    typeof error === "object" &&
    error != null &&
    "message" in error &&
    typeof (error as any).message === "string"
  )
}

/**
 * A helper function to create cache tags for lists
 * https://redux-toolkit.js.org/rtk-query/usage/automated-refetching#abstracting-common-providesinvalidates-usage
 */
export function providesList<R extends { id: string | number }[], T extends string>(
  resultsWithIds: R | undefined,
  tagType: T
) {
  return resultsWithIds
    ? [
      { type: tagType, id: "LIST" },
      ...resultsWithIds.map(({ id }) => ({ type: tagType, id })),
    ]
    : [{ type: tagType, id: "LIST" }]
}